import React from "react";
import {
  withGoogleMap,
  withScriptjs,
  Marker,
  GoogleMap,
} from "react-google-maps";

const Map = withScriptjs(
  withGoogleMap((props) => {
    const { center, onMapClick, onMarkerClick, marker, defaultZoom } = props;

    const renderMarker = () => {
      if (marker?.lat === "" && marker?.lng === "") {
        return;
      }

      return <Marker position={marker} onClick={(e) => onMarkerClick(e)} />;
    };

    return (
      <GoogleMap
        defaultZoom={defaultZoom}
        center={center}
        onClick={(e) => onMapClick(e)}
      >
        {renderMarker()}
      </GoogleMap>
    );
  })
);

export default Map;
